import { DebtorContactDTO } from '@/models/back-office-pages/clients'
import { InvoiceBatchVerificationDTO } from '@/models/back-office-pages/invoices'
import { Currency } from '@/models/common'
import { Direction } from '@/models/table'

export enum TaskAssignmentStatus {
  DONE = 'DONE',
  OPEN = 'OPEN',
}

export enum TaskFilter {
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
  DONE = 'DONE',
  OPEN = 'OPEN',
  UNASSIGNED = 'UNASSIGNED',
  FAB_LEGACY = 'FAB_LEGACY',
}

export enum TaskAction {
  AUTOMATIC_TRANSFER_INVOICE_TO_INSURER = 'AUTOMATIC_TRANSFER_INVOICE_TO_INSURER',
  CALL_CLIENT = 'CALL_CLIENT',
  CALL_DEBTOR = 'CALL_DEBTOR',
  CHECK_IF_FEE_CALC_SHOULD_STOP = 'CHECK_IF_FEE_CALC_SHOULD_STOP',
  EMAIL_DEBTOR = 'EMAIL_DEBTOR',
  PREPARE_INVOICE_SUBMISSION_TO_INSURER = 'PREPARE_INVOICE_SUBMISSION_TO_INSURER',
  PURCHASE_STOP = 'PURCHASE_STOP', //auto
  REMINDER_I = 'REMINDER_I', //auto
  REMINDER_II = 'REMINDER_II', //auto
  REMINDER_III = 'REMINDER_III', //auto
  REQUEST_RECOURSE_TO_CLIENT = 'REQUEST_RECOURSE_TO_CLIENT',
  REVIEW = 'REVIEW',
  SEND_TO_INSURANCE = 'SEND_TO_INSURANCE',
  OTHER = 'OTHER',
}

export enum TaskActionsWithoutAutoActions {
  AUTOMATIC_TRANSFER_INVOICE_TO_INSURER = 'AUTOMATIC_TRANSFER_INVOICE_TO_INSURER',
  CALL_CLIENT = 'CALL_CLIENT',
  CALL_DEBTOR = 'CALL_DEBTOR',
  CHECK_IF_FEE_CALC_SHOULD_STOP = 'CHECK_IF_FEE_CALC_SHOULD_STOP',
  EMAIL_DEBTOR = 'EMAIL_DEBTOR',
  PREPARE_INVOICE_SUBMISSION_TO_INSURER = 'PREPARE_INVOICE_SUBMISSION_TO_INSURER',
  REQUEST_RECOURSE_TO_CLIENT = 'REQUEST_RECOURSE_TO_CLIENT',
  REVIEW = 'REVIEW',
  SEND_TO_INSURANCE = 'SEND_TO_INSURANCE',
  OTHER = 'OTHER',
}

export interface TaskDTO {
  assignedTo: string
  clientCompanyName: string
  debtorCompanyName: string
  id: string
  invoices: number
  outstandingAmount: number
  status: TaskAssignmentStatus
  taskAction: TaskAction
  taskDue: Date
  lastUpdate: Date
  totalAmount: number
  due: number
  overdueDays: number
  closedBy: string
  closedBySystem: boolean
  currency: Currency
}

export interface Page_TaskDTO {
  content: Array<TaskDTO>
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface DebtCollectionData {
  creditManagementTasks: Page_TaskDTO
}

export interface DebtCollectionVariables {
  pageSize?: number
  pageNum?: number
  taskFilter: TaskFilter
  currency?: Array<Currency>
  sortDirection?: Direction
  sortField?: string
}

export interface DebtCollectorListDTO {
  email: string
  fullName: string
  id: string
}

export interface DebtCollectorsData {
  getDebtCollectors: Array<DebtCollectorListDTO>
}

export interface AssignTasksData {
  assignCreditManagementTasks: Array<string>
}

export interface AssignTasksVariables {
  tasks: Array<string>
  assignee: string
}

export interface AssignTasksToMeData {
  assignCreditManagementTasksToMe: Array<string>
}

export interface AssignTasksToMeVariables {
  tasks: Array<string>
}

export enum AssignTasksFieldNames {
  TASKS = 'tasks',
  ASSIGNEE = 'assignee',
}

export enum TaskInvoiceStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  OVERDUE = 'OVERDUE',
}

export interface TaskInvoiceDTO {
  id: string
  invoiceNumber: string
  issueDate: Date
  dueDate: Date
  overDue: number
  invoiceAmount: number
  factorAmount: number
  fundedAmount: number
  purchasedAt: Date
  paidAmount: number
  outstandingAmount: number
  interestAmount: number
  status: TaskInvoiceStatus
  currency: Currency
}

export interface InvoiceNumberDTO {
  id: string
  invoiceNumber: string
}

export interface InvoicesBillingAddressesDTO {
  debtorContact: DebtorContactDTO
  invoiceNumbers: [InvoiceNumberDTO]
}

export interface TaskInvoiceDetailsDTO {
  clientCompanyName: string
  debtorCompanyName: string
  debtorPhone: string
  clientDebtorId: string
  clientId: string
  taskAction: TaskAction
  status: TaskAssignmentStatus
  legacyTask: boolean
  invoices: Array<TaskInvoiceDTO>
  invoicesBillingAddresses: Array<InvoicesBillingAddressesDTO>
}

export interface TaskInvoicesDetailsData {
  loadTaskInvoiceDetails: TaskInvoiceDetailsDTO
}

export interface TaskInvoicesDetailsVariables {
  id: string
}

export interface TaskRemainingDTO {
  action: TaskAction
  id: string
  started: Date
  willBeCreatedInDays: number
  taskInformation: string
}

export interface TaskHistoryDTO {
  action: TaskAction
  closed: Date
  due: Date
  id: string
  status: TaskAssignmentStatus
  taskInformation: string
}

export interface TaskDetailsDTO {
  id: string
  assignedToMe: boolean
  legacyTask: boolean
  remainingTasks: Array<TaskRemainingDTO>
  tasks: Array<TaskHistoryDTO>
  taskActionDetails: TaskActionDetailsDTO
}

export interface TaskDetailsData {
  loadTaskDetails: TaskDetailsDTO
}

export interface TaskDetailsVariables {
  id: string
}

export interface EmailAttachmentDTO {
  emailContentFileName: string
  id: string
  pdfAttachmentFileName: string
  emailElmFileName: string
}

export interface TaskActionDetailsDTO {
  closed: Date
  created: Date
  dueDate: string
  id: string
  status: TaskAssignmentStatus
  taskAction: TaskAction
  taskInformation: string
  emailAttachment: EmailAttachmentDTO
}

export interface TaskActionData {
  loadTaskAction: TaskActionDetailsDTO
}

export interface TaskActionVariables {
  taskId: string
}

export interface RescheduleTaskData {
  rescheduleCreditManagementTask: TaskDetailsDTO
}

export interface RescheduleTaskVariables {
  taskInformation: string
  dueDate: string
  taskId: string
}

export interface RescheduleTaskFormData {
  taskInformation: string
  dueDate: string
}

export enum RescheduleTaskFieldNames {
  DUE_DATE = 'dueDate',
  INFORMATION = 'taskInformation',
}

export interface RescheduleTasksData {
  rescheduleBatchOfCreditManagementTask: TaskDetailsDTO[]
}

export interface RescheduleTasksVariables {
  taskInformation: string
  dueDate: string
  taskIds: string[]
}

export interface MarkTaskAsDoneData {
  markCreditManagementTaskAsDone: TaskDetailsDTO
}

export interface MarkTaskAsDoneVariables {
  taskId: string
}

export interface MarkTasksAsDoneData {
  markBatchOfCreditManagementTaskAsDone: TaskDetailsDTO[]
}

export interface MarkTasksAsDoneVariables {
  taskIds: string[]
}

export interface DebtorCmpFileDTO {
  content: string
  fileName: string
  size: number
}

export interface DownloadEmailData {
  downloadDebtorCmpEmailContent: DebtorCmpFileDTO
}

export interface DownloadEmailVariables {
  id: string
}

export interface DownloadEmailAttachmentData {
  downloadDebtorCmpPdfAttachment: DebtorCmpFileDTO
}

export interface DownloadEmailAttachmentVariables {
  id: string
}

export interface DownloadEmailEmlData {
  downloadDebtorCmpEmailElmFile: DebtorCmpFileDTO
}

export interface DownloadEmailEmlVariables {
  id: string
}

export interface AddNewTaskData {
  createAdditionalCreditManagementTask: TaskDetailsDTO
}

export interface AddNewTaskVariables {
  taskInformation: string
  dueDate: string
  taskAction: TaskAction
  taskId: string
}

export interface AddNewTaskFormData {
  taskInformation: string
  dueDate: string
  taskAction: TaskAction
}

export enum NewTaskFieldNames {
  DUE_DATE = 'dueDate',
  INFORMATION = 'taskInformation',
  ACTION = 'taskAction',
}

export interface TaskCommentListDTO {
  archived: boolean
  taskId: string
  comment: string
  createdBy: string
  createdByEmail: string
  createdById: string
  createdOn: Date
  flagged: boolean
  id: string
  updatedBy: string
  updatedByEmail: string
  updatedById: string
  updatedOn: Date
}

export interface TaskCommentDTO {
  archived: boolean
  taskId: string
  comment: string
  createdBy: string
  createdByEmail: string
  createdById: string
  createdOn: Date
  flagged: boolean
  id: string
  updatedBy: string
  updatedByEmail: string
  updatedById: string
  updatedOn: Date
}

export interface GetTaskCommentsData {
  getTaskComments: Array<TaskCommentListDTO>
}

export interface GetTaskCommentsVariables {
  taskId: string
}

export interface GetTaskCommentByIdData {
  getTaskCommentById: TaskCommentDTO
}

export interface GetTaskCommentsByIdVariables {
  commentId: string
}

export interface AddTaskCommentData {
  addTaskComment: TaskCommentDTO
}

export interface AddTaskCommentVariables {
  taskId: string
  comment: string
}

export interface UpdateTaskCommentData {
  updateTaskComment: TaskCommentDTO
}

export interface UpdateTaskCommentVariables {
  comment: string
  commentId: string
}

export interface MarkTaskCommentAsFlaggedData {
  markTaskCommentAsFlagged: TaskCommentDTO
}

export interface MarkTaskCommentAsFlaggedVariables {
  commentId: string
}

export interface MarkTaskCommentAsUnflaggedData {
  markTaskCommentAsUnflagged: TaskCommentDTO
}

export interface MarkTaskCommentAsUnflaggedVariables {
  commentId: string
}

export interface MarkTaskCommentAsArchivedData {
  markTaskCommentAsArchived: TaskCommentDTO
}

export interface MarkTaskCommentAsArchivedVariables {
  commentId: string
}

export interface MarkTaskCommentAsUnarchivedData {
  markTaskCommentAsUnarchived: TaskCommentDTO
}

export interface MarkTaskCommentAsUnarchivedVariables {
  commentId: string
}

export interface SendToInsuranceInvoicesData {
  sendToInsuranceInvoices: InvoiceBatchVerificationDTO
}

export interface SendToInsuranceInvoicesVariables {
  invoiceIds: string[]
}

export interface SetToOverdueInvoicesData {
  setToOverdueInvoices: InvoiceBatchVerificationDTO
}

export interface SetToOverdueInvoicesVariables {
  invoiceIds: string[]
}

export interface SendToLegalInvoicesData {
  sendToLegalInvoices: InvoiceBatchVerificationDTO
}

export interface SendToLegalInvoicesVariables {
  invoiceIds: string[]
}

export interface ChangePaymentTermData {
  shiftCmpSchedule: InvoiceBatchVerificationDTO
}

export interface ChangePaymentTermVariables {
  delta: number
  taskId: string
}

export interface ChangePaymentTermFormValues {
  delta: number
}

export enum ChangePaymentTermFieldsNames {
  DELTA = 'delta',
}

export type DebtCollectionInvoicesActions = SendToInsuranceInvoicesVariables | SendToLegalInvoicesVariables | SetToOverdueInvoicesVariables
